module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/3_4.e4a5ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/3_4.jpg
// module id = XJKN
// module chunks = 0